module.exports = __webpack_public_path__ + "img/warning.ab20d3d0.svg";